"use client";

import { signIn } from "next-auth/react";
import { useStoreSelector } from "@workspace/core";
import { observer } from "mobx-react-lite";
import { TrainingLoader } from "@workspace/ui/common";
import { useEffect } from "react";
import { when } from "mobx";
import { useSearchParams } from "next/navigation";

function SignIn() {
  const authStore = useStoreSelector((store) => store.auth);
  const workspaceStore = useStoreSelector((store) => store.workspace);
  const searchParams = useSearchParams();

  useEffect(() => {
    const redirectTo = searchParams.get("redirect_to") || "";

    const authDispose = when(
      () => authStore.status === "unauthenticated",
      () => {
        let callbackUrl = "/auth";

        try {
          if (redirectTo && redirectTo !== "/") {
            const validatedUrl = new URL(redirectTo, window.location.origin);
            callbackUrl = `/auth?redirect_to=${encodeURIComponent(validatedUrl.pathname)}`;
          } else {
            callbackUrl = "/auth";
          }
        } catch (e) {
          console.error(e);
          callbackUrl = "/auth";
        }
        void signIn("keycloak", { callbackUrl });
      },
    );

    const workspaceDispose = when(
      () => {
        return workspaceStore.isWorkspaceReady;
      },
      () => {
        if (redirectTo && redirectTo !== "/") {
          window.location.href = `${process.env.NEXT_PUBLIC_LANDING_URL}${redirectTo}`;
          return;
        }

        if (
          workspaceStore.workspaces!.some(
            (workspace) => workspace.role === "admin",
          )
        ) {
          window.location.href = `${process.env.NEXT_PUBLIC_ADMIN_URL}/admin`;
          return;
        }

        return (window.location.href = `${process.env.NEXT_PUBLIC_ADMIN_URL}/dashboard`);
      },
    );

    return () => {
      authDispose();
      workspaceDispose();
    };
  }, [authStore, workspaceStore, searchParams]);

  return <TrainingLoader />;
}

const _SignIn = observer(SignIn);
export default _SignIn;
